import React from "react"
const AltSiteName = " - ClozeSure"
const NewsBaseURL = "/our-culture/latest-property-news/"
const TeamBaseURL = "/our-culture/meet-the-team/"
const AreaguideBaseURL = "/our-culture/areas-we-cover/"
export { AltSiteName, NewsBaseURL, TeamBaseURL, AreaguideBaseURL }
